import React from 'react';

import { OutlinedInput } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styled from 'styled-components';

import { Typography6 } from 'uiToolkit/Typography';

const CustomRoleName = ({ name, handleNameChange }) => (
  <Container>
    <Typography6 weight={400} bottomGutter={1.5}>
      Access name
    </Typography6>
    <StyledTextField
      variant="outlined"
      placeholder="Enter Access Name"
      size="normal"
      margin="dense"
      value={name}
      onChange={handleNameChange}
    />
  </Container>
);

const Container = styled.div`
  padding: 1.5rem;
`;

const StyledTextField = withStyles({
  root: {
    width: '40rem',
  },
  input: {
    paddingLeft: '1rem',
    fontSize: '0.875rem',
  },
})(OutlinedInput);

export default CustomRoleName;
